import MicroModal from 'micromodal';
import { Component } from '@verndale/core';

class Search extends Component {
  setupDefaults() {
    this.dom = {
      trigger: this.el.querySelector('.header-search__trigger'),
      modal: this.el.querySelector('.search-modal'),
      searchModalForm: this.el.querySelector('.search-modal__form'),
      searchModalFormInput: this.el.querySelector('.search-modal__input'),
      searchForm: document.querySelector('.search-results__search-bar-form'),
      searchFormInput: document.querySelector('.search-results__search-bar-form #search-input')
    };

    if (this.dom.modal) {
      this.modalId = this.dom.modal.id;
    }

    this.isModalOpen = false;
  }

  addListeners() {
    if (this.dom.trigger) {
      this.dom.trigger.addEventListener('click', ::this.handleTriggerClick);
      this.dom.trigger.addEventListener('keydown', this.handleTab.bind(this));
    }
    if (this.dom.searchModalForm) {
      this.dom.searchModalForm.addEventListener('submit', ::this.handleSearchModalFormEmptySubmissions)
    }
    if (this.dom.searchForm) {
      this.dom.searchForm.addEventListener('submit', ::this.handleSearchFormEmptySubmissions)
    }
    if (this.dom.modal) {
      // Event listeners to manage focus inside the modal
      this.dom.modal.addEventListener('keydown', this.handleTab.bind(this));
    }
  }

  handleTriggerClick() {
    if (!this.modalId) {
      return;
    }
    if (this.isModalOpen) {
      MicroModal.close(this.modalId);
    } else {
      MicroModal.show(this.modalId, {
        onShow: ::this.handleSearchModalShow,
        onClose: ::this.handleSearchModalClose
      });
    }
  }

  handleTab(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      const focusableElements = this.dom.modal.querySelectorAll('button, input');
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          setTimeout(() => this.dom.trigger.focus(), 0);
        } else if (document.activeElement === this.dom.trigger) {
          setTimeout(() => lastFocusableElement.focus(), 0);
        } else {
          setTimeout(() => firstFocusableElement.focus(), 0);
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          setTimeout(() => this.dom.trigger.focus(), 0);
        } else if (document.activeElement === this.dom.trigger) {
          setTimeout(() => firstFocusableElement.focus(), 0);
        } else {
          setTimeout(() => lastFocusableElement.focus(), 0);
        }
      }
    }
  }

  handleSearchModalShow() {
    this.isModalOpen = true;
    this.el.classList.add('header-search--active');
  }

  handleSearchModalClose() {
    this.isModalOpen = false;
    this.el.classList.remove('header-search--active');
  }

  handleSearchModalFormEmptySubmissions(e) {
    if (!this.dom.searchModalFormInput.value) return e.preventDefault();
  }

  handleSearchFormEmptySubmissions(e) {
    if (!this.dom.searchFormInput.value) return e.preventDefault();
  }
}

export default Search;
